module.exports = __webpack_public_path__ + "static/img/guan3.7e741f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guan3.png
// module id = uLD7
// module chunks = 46